// Documento: Configurar WhatsApp Embedded Signup en Etiqueta Blanca
// Categoría: Etiqueta Blanca
// Última actualización: 2024-12-28

const document = {
  "id": "configurar-whatsapp-embedded-signup-etiqueta-blanca",
  "title": "Configurar WhatsApp Embedded Signup en Etiqueta Blanca",
  "category": "Etiqueta Blanca",
  "description": "Guía completa para configurar WhatsApp Embedded Signup en su etiqueta blanca. Este proceso permite a sus clientes conectar WhatsApp en menos de 5 minutos a través de una integración directa con Meta.",
  "explanations": [
    {
      "title": "Requisitos Previos",
      "content": "Para poder ofrecer esto a sus clientes hay dos pre-requisitos:\n\n• **Ser una empresa verificada por Meta**\n• **Convertirse en un proveedor de tecnología para Meta**"
    }
  ],
  "steps": [
    {
      "title": "Acceder al portal de desarrolladores de Facebook",
      "content": "Diríjase hacia https://developers.facebook.com/ y haga click en \"Mis Apps\" o en \"Comenzar\"",
      "images": [
        "/documents/wp-es/1.png"
      ]
    },
    {
      "title": "Crear nueva aplicación",
      "content": "Haga click en \"Crear App\"",
      "images": [
        "/documents/wp-es/2.png"
      ]
    },
    {
      "title": "Configurar información básica",
      "content": "Complete el nombre de la app y el email de contacto, luego haga click en \"Siguiente\"",
      "images": [
        "/documents/wp-es/3.png"
      ]
    },
    {
      "title": "Seleccionar tipo de aplicación",
      "content": "Seleccione \"Otro\" y haga click en \"Siguiente\"",
      "images": [
        "/documents/wp-es/4.png"
      ]
    },
    {
      "title": "Seleccionar caso de uso",
      "content": "Seleccione \"Negocios\" y haga click en \"Siguiente\"",
      "images": [
        "/documents/wp-es/5.png"
      ]
    },
    {
      "title": "Finalizar creación de app",
      "content": "Verifique el nombre de la app, el email y seleccione el portfolio comercial de Meta a vincular para esta aplicación, luego haga click en \"Crear App\"",
      "images": [
        "/documents/wp-es/6.png"
      ]
    },
    {
      "title": "Agregar plataforma website",
      "content": "Acceda a \"Configuración de la app\" > \"Básica\". Haga scroll hacia abajo y haga click en \"Agregar plataforma\", luego selecciones \"Website\" y haga click en \"Siguiente\"",
      "images": [
        "/documents/wp-es/7.png"
      ]
    },
    {
      "title": "Configurar URL del sitio",
      "content": "En el campo \"URL del sitio\" agregue su sub-dominio (app.DOMINIO) y guarde los cambios",
      "images": [
        "/documents/wp-es/8.png"
      ]
    },
    {
      "title": "Configurar Webhook",
      "content": "Luego haga click en \"Agregar producto\" y haga click en \"Configurar\" Webhook",
      "images": [
        "/documents/wp-es/9.png"
      ]
    },
    {
      "title": "Configurar URL de devolución de llamada",
      "content": "Seleccione \"WhatsApp Business Account\" y complete en \"URL de devolución de llamada\" su sub-dominio seguido de /php/whatsapp.",
      "images": [
        "/documents/wp-es/10.png"
      ]
    },
    {
      "title": "Obtener API Key de etiqueta blanca",
      "content": "El token debe ser su API key de etiqueta blanca, la puede conseguir desde su etiqueta banca en Ajustes > Otros > Whitelabel Master API Key",
      "images": [
        "/documents/wp-es/11.png"
      ]
    },
    {
      "title": "Verificar y suscribirse a campos del webhook",
      "content": "Seleccione \"WhatsApp Business Account\", complete los datos con las mismas credenciales y suscríbase a todos los campos del webhook. Si algunos dan error no se preocupe y siga con los siguientes. Luego haga click en \"Verificar y guardar\"",
      "images": [
        "/documents/wp-es/12.png"
      ]
    },
    {
      "title": "Agregar producto WhatsApp",
      "content": "Haga click en \"Agregar producto\" y luego haga click en \"Configurar\" en WhatsApp. Confirme la ventana de inicio de WhatsApp.",
      "images": [
        "/documents/wp-es/13.png"
      ]
    },
    {
      "title": "Agregar inicio de sesión con Facebook",
      "content": "Haga click en \"Agregar producto\" y luego haga click en \"Configurar\" en Inicio de sesión con Facebook para empresas.",
      "images": [
        "/documents/wp-es/14.png"
      ]
    },
    {
      "title": "Configurar OAuth y dominios",
      "content": "Dentro de \"Inicio de sesión con Facebook\" Haga click en Configurar. Luego complete los campos \"URI de redireccionamiento de OAuth válidos\" con el valor https://SUBDOMINIO/php/auth.php. Seleccione \"Si\" para iniciar sesión con el SDK para JavaScript. Agregue su subdominio a los dominios permitidos y guarde los cambios.",
      "images": [
        "/documents/wp-es/15.png"
      ]
    },
    {
      "title": "Configurar política de privacidad",
      "content": "Acceda a \"Configuración de la app\" y de click en \"Básica\". Complete el campo \"URL de la política de privacidad\". Ya tiene una URL disponible https://SUBDOMINIO/legal/privacy-policy. Recuerde guardar los cambios.",
      "images": [
        "/documents/wp-es/16.png"
      ]
    },
    {
      "title": "Solicitar acceso a public_profile",
      "content": "Acceda a \"Revisión de la app\" y de click en \"Permisos y funciones\", luego busque \"public_profile\" y haga click en \"Solicitar acceso avanzado\".",
      "images": [
        "/documents/wp-es/17.png"
      ]
    },
    {
      "title": "Verificar el negocio",
      "content": "Deberá verificar el negocio si es que no está verificado anteriormente, una vez verificado el negocio podrá continuar",
      "images": [
        "/documents/wp-es/18.png"
      ]
    },
    {
      "title": "Negocio verificado",
      "content": "Así se verá cuando su negocio esté verificado.",
      "images": [
        "/documents/wp-es/19.png"
      ]
    },
    {
      "title": "Continuar registro como proveedor",
      "content": "Hágase proveedor de tecnología: Desde WhatsApp, Inicio Rápido haga click en \"Continuar registro\"",
      "images": [
        "/documents/wp-es/20.png"
      ]
    },
    {
      "title": "Seleccionar tipo de proveedor",
      "content": "Seleccione \"Proveedor de tecnología independiente\" y haga click en \"Iniciar Registro\"",
      "images": [
        "/documents/wp-es/21.png"
      ]
    },
    {
      "title": "Completar registro de proveedor",
      "content": "Complete todos los pasos y siga las instrucciones de Meta.",
      "images": [
        "/documents/wp-es/22.png"
      ]
    },
    {
      "title": "Ejemplo de solicitud de permisos",
      "content": "Para ser socio tecnológico de Meta deberá solicitar dos permisos especiales:\n\n**whatsapp_business_messaging**\nCuando le pidan información complete con esto:\nWe are requesting whatsapp_business_messaging to allow businesses to send WhatsApp notifications to their customers. Notifications include order status updates. A business may need to send their customer who gave their phone number and consent to message them information on WhatsApp, like a ticket for an event. This permission also allows a business to automate customer support by automatically replying to customer messages. Without this permission, businesses cannot send messages on WhatsApp.\n\n**whatsapp_business_management**\nCuando le pidan información complete con esto:\nWe are requesting whatsapp_business_management to allow our platform to get the list of WhatsApp template messages associated with a WhatsApp Business Account. Without this permission, businesses cannot send WhatsApp notifications (Template Messages) because they cannot see the list of Template Messages inside our platform. We automatically get the list of template messages once a customer signs up on our platform, and businesses can also sync WhatsApp templates at any time inside our platform.\n\nEste es un ejemplo de como se debe completar al solicitar los permisos.",
      "images": [
        "/documents/wp-es/23.png"
      ]
    },
    {
      "title": "Enviar para revisión",
      "content": "Una vez completa toda la información, envíela para revisión",
      "images": [
        "/documents/wp-es/24.png"
      ]
    },
    {
      "title": "Continuar proceso de revisión",
      "content": "Una vez verificada la empresa podrá continuar con el proceso desde Revisión de la app, Permisos y funciones",
      "images": [
        "/documents/wp-es/25.png"
      ]
    },
    {
      "title": "Aceptar y confirmar",
      "content": "Acepte y confirme",
      "images": [
        "/documents/wp-es/26.png"
      ]
    },
    {
      "title": "Completar información final",
      "content": "Complete la información y haga click en \"Enviar\"",
      "images": [
        "/documents/wp-es/27.png"
      ]
    },
    {
      "title": "Verificar configuración Tech Provider",
      "content": "Una vez realizados todos los pasos anteriores a este podrá ver que en \"Inicio de sesión con Facebook para empresas\", \"Configuraciones\" se ah creado el registro \"Tech Provider Embedded Signup config\" que permitirá ofrecer la co-existencia de WhatsApp business app y WhatsApp API en su instancia de nuestra plataforma.",
      "images": [
        "/documents/wp-es/28.png"
      ]
    },
    {
      "title": "Configurar Webhooks final",
      "content": "Diríjase hacia Webhooks y complete con los datos, URL de devolución de la llamada: \"https://SUB_DOMAIN/php/whatsapp\" y en Token de verificación su \"Whitelabel Master API Key\" que puede encontrar en Ajustes > Otros > Whitelabel Master API Key. Luego haga click en \"Verificar y guardar\"",
      "images": [
        "/documents/wp-es/29.png"
      ]
    },
    {
      "title": "Suscribirse a campos del webhook",
      "content": "Suscríbase a todos los campos del webhook, si algunos dan error, no se preocupe y continue con los demás.",
      "images": [
        "/documents/wp-es/30.png"
      ]
    },
    {
      "title": "Activar aplicación",
      "content": "Active su aplicación y siga los pasos",
      "images": [
        "/documents/wp-es/31.png"
      ]
    },
    {
      "title": "Obtener credenciales de la app",
      "content": "Ya tiene todo lo necesario para poder conectar esta integración a su etiqueta blanca. Va a necesitar 3 datos para poder hacerlo: App ID, Secret Key y Configuration ID. Esto lo puede conseguir desde Configuración de la app > Básica",
      "images": [
        "/documents/wp-es/32.png"
      ]
    },
    {
      "title": "Obtener Configuration ID",
      "content": "Inicio de sesión con Facebook empresas > Configuraciones y copiar el ID de configuración",
      "images": [
        "/documents/wp-es/33.png"
      ]
    },
    {
      "title": "Conectar a etiqueta blanca",
      "content": "Diríjase a su etiqueta blanca, Ajustes > Integraciones > Meta App for WhatsApp automation y complete los datos\n\nListo, su integración con WhatsApp embedded signup está lista.",
      "images": [
        "/documents/wp-es/34.png"
      ]
    }
  ],
  "tags": [
    "etiqueta-blanca",
    "whatsapp",
    "embedded-signup",
    "meta",
    "facebook",
    "configuración",
    "integración",
    "proveedor-tecnológico"
  ],
  "lastUpdated": "2024-12-28",
  "difficulty": "avanzado"
};

export default document;
